import {fetchBaseQuery} from '@reduxjs/toolkit/query';

export const dmsBaseQuery = fetchBaseQuery({
  baseUrl: process.env.API_URL,
});
